const firebaseConfig = {
  apiKey: "AIzaSyB98wZABtFejVtN432NF_gg2Bxi78taxDM",
  authDomain: "med-city.firebaseapp.com",
  projectId: "med-city",
  storageBucket: "med-city.appspot.com",
  messagingSenderId: "1086763280808",
  appId: "1:1086763280808:web:eebdf7faaf40043272d59d",
};

export default firebaseConfig;